import DadosIniciais from '../ModulosCrefito/DadosIniciais'
import DadosEstabelecimento from '../ModulosCrefito/DadosEstabelecimento'
import Livre from './TiposTO/Livre'
import Consultorio from './TiposTO/Consultorio'
import Caps from './TiposTO/Caps'
import Clinica from './TiposTO/Clinica'
import Nasf from './TiposTO/Nasf'
import ExercicioIlegal from './TiposTO/ExercicioIlegal'
import RedeSocial from './TiposTO/RedeSocial'
import Ilpis from './TiposTO/Ilpis'
import Hospital from './TiposTO/Hospital'
import Cer from './TiposTO/Cer'
import Fechado from './Fechado'
import Cabecalho from '../../Views/Form/Cabecalho'
import Assinaturas from '../../Views/Form/Assinaturas'
import QrCode from '../../Views/Form/QrCode'
import AiView from '../AIs/AisTo/AiView'

import React from 'react'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ficha, setModo } from '../../../state/slices/formSlice'

const TermoDeVisitaTO = () => {
    const [tipo, setTipo] = useState()
    const id = window.location.pathname.slice(10)
    const dispatch = useDispatch()
    const [paf, setPaf] = useState({})

    useEffect(() => {
        const url = '/api/tvs/getTvTo'
        axios.post(url, {id})
            .then(res => {
                dispatch(ficha(res.data))
                dispatch(setModo())
                setTipo(res.data.tipo)
                setPaf(res.data.dadosEstabelecimento[0])
            })
            .catch(error => {
                alert(error)
            })
    }, [])

    return (
        <>
            <Cabecalho valor={paf} />
            <DadosIniciais modulo="dadosIniciais" />
            <DadosEstabelecimento modulo="dadosEstabelecimento" />
            {RenderFicha()}
            <Assinaturas profissao="de Terapia Ocupacional" />
            <QrCode tipo="brancoView" id={id}/>
            <AiView />
        </>
    )

    function RenderFicha() {
        if (tipo === "Livre") return <Livre />
        else if (tipo === "Consultório") return <Consultorio />
        else if (tipo === "Caps") return <Caps />
        else if (tipo === "Clínica") return <Clinica />
        else if (tipo === "Nasf") return <Nasf />
        else if (tipo === "Exercício Ilegal") return <ExercicioIlegal />
        else if (tipo === "Rede Social") return <RedeSocial />
        else if (tipo === "ILPIS") return <Ilpis />
        else if (tipo === "Hospital") return <Hospital />
        else if (tipo === "CER") return <Cer />
        else if (tipo === "Fechado/Desativado") return <Fechado />
    }
}

export default TermoDeVisitaTO